var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('net-resource'),_c('new-share-manuscript'),_c('today-adopt-manuscript')],1)}
var staticRenderFns = []

export { render, staticRenderFns }